import React, { useState } from 'react';
import { styled } from '@mui/material';
import moment from 'moment';

import { useViewport } from 'contexts/viewport';
import { Button, DatePicker, IconButton, ResponsiveDialog, Stack, Text } from 'shell/components';

const ScheduleModal = ({ visible, onSchedule, onCancel }) => {
    const { device } = useViewport();

    const [timestamp, setTimestamp] = useState(moment().hour(0).minute(0).second(0).millisecond(0));

    return (
        <ResponsiveDialog open={visible} onClose={onCancel}>
            <CustomStack alignItems={'flex-end'} spacing={4}>
                <Stack
                    sx={{ width: '100%' }}
                    alignItems={'center'}
                    device={device}
                    direction={'row'}
                    justifyContent={'space-between'}
                >
                    <Text variant={'h6'}>Schedule to Publish</Text>
                    <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={onCancel} />
                </Stack>
                <DatePicker
                    disabledDate={(date) => date.isSameOrBefore(moment().subtract(1, 'day'))}
                    forceTimeSelection
                    label={'Select a Date and Time'}
                    value={timestamp}
                    onChange={setTimestamp}
                />
                <Button sx={{ width: 'fit-content' }} onClick={() => onSchedule(timestamp)}>
                    Done
                </Button>
            </CustomStack>
        </ResponsiveDialog>
    );
};

const CustomStack = styled(Stack)(({ device }) => {
    return {
        ...(device !== 'mobile' && {
            width: '20rem',
        }),
    };
});

export default ScheduleModal;
